import React from 'react';

import {makeToolTipUrl} from "utils/DBUtils";

export const MemoryMatchHeadlineToolTip = (props) => (
  <div>
    The title of the break featured on the top.
    <br/>
    <img src={makeToolTipUrl('memory-match/1.CMS-MemMatch-headline.png')} width="100%"/>
  </div>
);

export const MemoryMatchIntroToolTip = (props) => (
  <div>
    Copy to introduce the break.
    <br/>
    <img src={makeToolTipUrl('memory-match/2.CMS-MemMatch-intro.png')} width="100%"/>
  </div>
);

export const MemoryMatchBackgroundColorToolTip = (props) => (
  <div>
    Color behind the image tiles.  Will prefill with result background color in sponsored breaks and default light blue for editorial.
    <br/>
    <img src={makeToolTipUrl('memory-match/3.CMS-MemMatch-bkg-color.png')} width="100%"/>
  </div>
);

export const MemoryMatchGridSizeToolTip = (props) => (
  <div>
    The total number of cards for the step.  The Default is 16 (8 pairs of cards).
  </div>
);

export const MemoryMatchCardFrontImageToolTip = (props) => (
  <div>
    The front side of the card that is consistent and is displayed before the user "flips" the card.  This can be customized for sponsored campaigns.
    <br/>
    <img src={makeToolTipUrl('memory-match/4.CMS-MemMatch-card-front-img.png')} width="100%"/>
  </div>
);

export const MemoryMatchCardPairToolTip = (props) => (
  <div>
    Unique image on the back side of the card.
    <br/>
    <img src={makeToolTipUrl('memory-match/5.CMS-MemMatch-card-pair.png')} width="100%"/>
  </div>
);



// WEBPACK FOOTER //
// ./public/components/break/tooltips/memory-match-tool-tips.jsx